var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCraneWsLoginLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    viewBox: "5.05 281.2 1014.02 275.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E76022;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000121264704762981744780000002798502197798475189_);}\n\t.st3{fill:url(#SVGID_00000106118565486983811500000002106007822593867401_);}\n\t.st4{fill:url(#SVGID_00000070082766921271319920000012977441434675811764_);}\n\t.st5{fill:url(#SVGID_00000013161148495464522730000015656184415499822771_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000176016308922274975350000006839003530442863776_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000018943324449961974850000004877247606743973761_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000065766695658888248220000012836663009899036552_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000152223929724934773220000001531893924271264129_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000011727421310294049770000012108998909484942778_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000178896271345653283900000008217924158214630811_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000088113154867932320100000009960656816540857742_);}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000020395269096595756690000004380802196896839324_);}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000168811959858889538710000007555826192240537014_);}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000140706097322516250100000007946844493923483062_);}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000075152852872392945790000007460054493936528317_);}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000107573837008996149400000007193133480393207194_);}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000083779800835769282690000014039327002833720978_);}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000171701969196783298610000004099501980530144405_);}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000137831739157802982820000000370532863241348481_);}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000016792473828367376300000001851362860392241032_);}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000000205497590927391030000014644540511810298555_);}\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000040561026271245604190000010368153887427826826_);}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000004514687676222080130000009244480911605654964_);}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000165950046116888266510000015118380167439701898_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M709.51,527.5l1.02,16.22c0.22,3.57,0.2,5.42,0.14,7.76h0.13c0.69-1.88,1.73-4.36,3.17-7.24l8.58-16.74h4.31    l1.82,16.43c0.29,3.17,0.49,5.63,0.46,7.55h0.14c0.77-2.32,1.56-4.56,2.73-7.32l7.79-16.66h5.04l-14.25,28.84h-4.59l-1.91-15.67    c-0.28-2.67-0.44-5.13-0.42-7.68h-0.12c-1.21,2.78-2.04,4.97-3.35,7.53l-8.27,15.82h-4.63l-2.66-28.84H709.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772.04,538.84c0,8.91-6.33,18.16-16.03,18.16c-7.22,0-11.26-5.35-11.26-11.84c0-9.53,6.62-18.31,16-18.31    C768.53,526.84,772.04,532.73,772.04,538.84z M749.86,544.96c0,4.69,2.61,8.12,6.84,8.12c5.82,0,10.24-7.54,10.24-14.25    c0-3.37-1.56-8.07-6.72-8.07C753.98,530.76,749.85,538.35,749.86,544.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M775.49,556.34l3.52-18.58c0.71-3.76,1.14-7.59,1.46-10.26h4.36c-0.23,2.01-0.47,4.02-0.8,6.27h0.17    c1.89-3.95,4.97-6.92,8.84-6.92c0.46,0,1.03,0.04,1.41,0.11l-0.96,4.88c-0.35-0.07-0.79-0.1-1.35-0.1c-4.28,0-8.1,5.19-9.34,11.89    l-2.38,12.72H775.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M794.41,556.34l8.05-42.35h4.92l-5.07,26.55h0.12c0.88-1.01,1.94-2.11,2.7-2.91l10.16-10.14h6.11    l-12.59,11.84l8.61,17h-5.44l-6.95-14.24l-3.65,3.26l-2.07,10.98H794.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M832.68,551.33c1.36,0.81,3.83,1.8,6.2,1.79c3.33,0,5.49-2.15,5.49-4.71c0-2.25-1.01-3.66-4.01-5.32    c-3.34-1.85-5.21-4.4-5.21-7.35c0-5.04,4.37-8.9,10.45-8.9c2.62,0,4.92,0.7,6,1.43l-1.39,3.74c-0.99-0.58-2.82-1.31-4.97-1.31    c-3.02,0-5.14,1.88-5.14,4.33c0,2.12,1.39,3.4,3.97,4.86c3.21,1.82,5.39,4.34,5.39,7.58c0,6.06-4.93,9.5-11.01,9.5    c-3.1,0-5.87-0.98-7.18-1.98L832.68,551.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M854.69,556.34l3.83-20.45c0.63-3.21,1.02-6,1.34-8.39h4.36l-0.76,5.41h0.14c2.7-4.02,6.33-6.07,10.16-6.07    c4.39,0,6.53,2.79,6.74,6.43c2.59-4.18,6.26-6.37,10.6-6.43c3.34,0,7.01,2.13,7.01,7.57c0,1.33-0.18,3.27-0.48,4.9l-3.22,17.03    h-4.83l3.11-16.62c0.21-1.12,0.42-2.57,0.42-3.77c0-3.05-1.16-5.01-4.35-5.01c-3.61,0-7.87,4.15-9.06,10.61l-2.75,14.78h-4.81    l3.22-16.93c0.24-1.29,0.39-2.4,0.39-3.52c0-2.43-0.68-4.94-4.33-4.94c-3.58,0-8.11,4.77-9.21,10.89l-2.67,14.5H854.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M922,556.34c-0.02-1.74,0.27-4.46,0.64-7.45h-0.13c-3.12,5.99-7.1,8.11-11.17,8.11    c-5.11,0-8.29-4.06-8.29-9.53c0-10.05,7.39-20.63,19.94-20.63c2.77,0,5.78,0.47,7.78,1.09l-2.94,15.04    c-0.96,5.02-1.35,10.18-1.22,13.37H922z M925.21,531.19c-0.69-0.22-1.76-0.41-3.43-0.41c-7.47,0-13.57,7.77-13.6,15.79    c-0.02,3.22,1.12,6.36,4.92,6.36c4.14,0,8.99-5.38,10.43-13.05L925.21,531.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M934.12,556.34l3.52-18.58c0.71-3.76,1.14-7.59,1.46-10.26h4.36c-0.23,2.01-0.47,4.02-0.8,6.27h0.17    c1.89-3.95,4.97-6.92,8.84-6.92c0.46,0,1.03,0.04,1.41,0.11l-0.96,4.88c-0.35-0.07-0.79-0.1-1.35-0.1c-4.28,0-8.1,5.19-9.34,11.89    l-2.38,12.72H934.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M967.55,519.75l-1.48,7.75h6.89l-0.77,3.87h-6.9l-2.66,14.02c-0.31,1.61-0.57,3.1-0.57,4.6    c0,1.72,0.82,2.8,2.73,2.8c0.89,0,1.68-0.06,2.33-0.23l-0.24,3.89c-0.88,0.34-2.38,0.52-3.82,0.52c-4.36,0-6.07-2.65-6.07-5.6    c0-1.68,0.21-3.33,0.63-5.41l2.82-14.6h-4.13l0.75-3.87h4.14l1.22-6.5L967.55,519.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M993.87,554.69c-2.18,1.23-5.67,2.28-9.54,2.28c-7.66,0-10.97-5.22-10.97-11.61    c0-8.69,6.45-18.52,15.74-18.52c5.49,0,8.47,3.27,8.47,7.4c0,7.58-8.54,9.57-19.2,9.37c-0.24,1.25-0.07,3.94,0.58,5.49    c1.16,2.6,3.45,3.88,6.42,3.88c3.43,0,6-1.02,7.77-1.98L993.87,554.69z M988.4,530.69c-4.71,0-8.27,4.6-9.47,9.11    c7.77,0.09,13.86-0.95,13.86-5.44C992.78,531.99,990.97,530.69,988.4,530.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1000.08,556.34l3.52-18.58c0.71-3.76,1.14-7.59,1.46-10.26h4.36c-0.23,2.01-0.47,4.02-0.8,6.27h0.17    c1.89-3.95,4.97-6.92,8.84-6.92c0.46,0,1.03,0.04,1.41,0.11l-0.96,4.88c-0.35-0.07-0.79-0.1-1.35-0.1c-4.28,0-8.1,5.19-9.34,11.89    l-2.38,12.72H1000.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.0166,
    y1: 482.8301,
    x2: 509.0166,
    y2: 330.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#232F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    style: {
      stopColor: "#0069AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95A0C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M529.47,425.82h25.4v10.53c0,15.48-3.57,27.11-10.68,34.86c-7.13,7.74-18.75,11.62-34.87,11.62    c-15.7,0-27.32-3.77-34.86-11.31c-7.54-7.54-11.31-19.26-11.31-35.17v-59.5c0-15.7,3.77-27.37,11.31-35.01    c7.54-7.65,19.26-11.47,35.17-11.47c15.9,0,27.43,3.82,34.56,11.47c7.11,7.64,10.68,19.32,10.68,35.01v9.91h-25.1v-9.91    c0-14.87-6.7-22.32-20.14-22.32c-13.64,0-20.45,7.45-20.45,22.32v59.5c0,14.87,6.71,22.31,20.14,22.31    c13.43,0,20.15-7.44,20.15-22.31V425.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170259001605293147010000011538670510340205213_",
    gradientUnits: "userSpaceOnUse",
    x1: 621.0265,
    y1: 480.9656,
    x2: 621.0265,
    y2: 330.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#232F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    style: {
      stopColor: "#0069AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95A0C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170259001605293147010000011538670510340205213_)"
    },
    d: "M585.24,480.97V332.24h24.8l0.93,25.4    h1.23c2.89-8.68,7.02-15.38,12.39-20.14c5.37-4.74,11.98-7.13,19.83-7.13c4.33,0,8.47,1.04,12.39,3.1v24.48    c-3.1-2.06-7.74-3.1-13.94-3.1c-8.27,0-14.87,2.48-19.83,7.43c-4.97,4.96-8.68,14.05-11.16,27.28v91.4H585.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078745548143709932150000009405268753479510933_",
    gradientUnits: "userSpaceOnUse",
    x1: 722.9799,
    y1: 482.8301,
    x2: 722.9799,
    y2: 330.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#232F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    style: {
      stopColor: "#0069AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95A0C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078745548143709932150000009405268753479510933_)"
    },
    d: "M745.75,480.97l-0.93-18.9h-1.23    c-3.32,5.79-7.6,10.69-12.87,14.72c-5.27,4.03-12.75,6.05-22.46,6.05c-11.77,0-20.15-2.99-25.1-8.99    c-4.96-5.99-7.44-14.03-7.44-24.17V434.8c0-6.4,0.73-11.93,2.16-16.57c1.45-4.65,3.73-8.57,6.83-11.77    c3.1-3.21,7.17-5.99,12.24-8.38c5.06-2.37,11.2-4.59,18.44-6.66c3.29-1.03,6.66-2.02,10.06-2.94c3.41-0.93,6.46-1.96,9.14-3.1    c2.69-1.14,4.85-2.53,6.51-4.19c1.65-1.64,2.49-3.71,2.49-6.2v-6.19c0-10.12-6.42-15.18-19.22-15.18    c-14.05,0-21.07,5.57-21.07,16.72v9.61h-25.1v-12.71c0-12.39,4.18-21.63,12.54-27.73c8.37-6.08,20.09-9.14,35.17-9.14    c29.54,0,44.32,11.56,44.32,34.7v115.88H745.75z M743.89,399.16c-3.1,2.27-5.99,3.84-8.68,4.66c-2.68,0.82-6.92,2.06-12.71,3.71    c-8.66,2.69-14.24,5.67-16.72,8.98c-2.48,3.32-3.71,7.85-3.71,13.64v13.33c0,10.54,5.88,15.8,17.66,15.8    c6.19,0,11.2-1.44,15.02-4.34c3.83-2.88,6.87-7.32,9.14-13.33V399.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038392318638756015430000017301241278061710229_",
    gradientUnits: "userSpaceOnUse",
    x1: 847.8495,
    y1: 480.9656,
    x2: 847.8495,
    y2: 330.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#232F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    style: {
      stopColor: "#0069AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95A0C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038392318638756015430000017301241278061710229_)"
    },
    d: "M868.45,480.97V374.99    c0-14.03-6.4-21.07-19.2-21.07c-6.2,0-10.9,1.65-14.1,4.96c-3.19,3.3-5.94,8.88-8.21,16.72v105.36h-26.65V332.24h24.8l0.93,21.38    h1.23c3.3-8.06,7.59-13.95,12.86-17.67c5.27-3.71,11.83-5.58,19.67-5.58c10.54,0,19.11,3.36,25.73,10.07    c6.61,6.72,9.91,16.58,9.91,29.6v110.92H868.45z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178923146312026285850000013393368915853284012_",
    gradientUnits: "userSpaceOnUse",
    x1: 972.4132,
    y1: 482.8301,
    x2: 972.4132,
    y2: 330.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#232F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    style: {
      stopColor: "#0069AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95A0C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178923146312026285850000013393368915853284012_)"
    },
    d: "M1019.05,436.35    c0,30.99-15.7,46.48-47.1,46.48c-15.7,0-27.32-3.77-34.86-11.31c-7.54-7.54-11.31-19.26-11.31-35.17v-59.5    c0-15.7,3.77-27.37,11.31-35.01c7.54-7.65,19.26-11.47,35.17-11.47c31.19,0,46.79,15.49,46.79,46.48v36.88h-67.24v23.23    c0,14.87,6.72,22.32,20.14,22.32c13.85,0,20.77-7.45,20.77-22.32v-7.43h26.33V436.35z M992.71,376.24    c0-14.87-6.81-22.31-20.45-22.31c-13.64,0-20.45,7.44-20.45,22.31v17.66h40.91V376.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000075138785526469115860000005227712716844614286_",
    cx: -58.9137,
    cy: 577.7455,
    r: 287.0275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F8B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31F22"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000075138785526469115860000005227712716844614286_)"
    },
    d: "     M85.54,437.27c-17.87,14.29-41.35,23.69-80.48,23.38c60.83,36.61,133.95,38.62,187.65-1.17     C156.8,438.14,120.54,421.58,85.54,437.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111910151988067723210000010596392399276307885_",
    gradientUnits: "userSpaceOnUse",
    x1: -117.7706,
    y1: 463.7819,
    x2: 89.1134,
    y2: 463.7819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000111910151988067723210000010596392399276307885_)"
    },
    d: "     M5.06,460.66c60.83,36.61,133.95,38.62,187.65-1.17c-13.56-8.08-27.17-15.43-40.78-20.65C112.58,472.09,58.89,476.71,5.06,460.66     z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070094345554588264000000016719297117628529849_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.1403,
    y1: 450.0823,
    x2: 172.6665,
    y2: 450.0823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000070094345554588264000000016719297117628529849_)"
    },
    d: "     M85.54,437.27c33.48-8.49,66.05,8.74,92.48,31.82c5.04-2.91,9.92-6.08,14.7-9.61C156.8,438.14,120.54,421.58,85.54,437.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000082360264066255175100000014669517422959962288_",
    cx: 583.5737,
    cy: 288.9608,
    r: 650.7089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F8B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31F22"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000082360264066255175100000014669517422959962288_)"
    },
    d: "      M257.55,365.41c-124.31-32.66-107.27,11.56-172.01,71.87c84-37.7,175.27,110.52,251.97,64.73      c-19.04-4.82-35.13-15.86-45.18-39.78c34.83,17.44,66.74,15.53,96.23-2.65c-24.53-2.69-46.92-12.61-65.49-35.26      c52.35,13.96,87.92,1.87,102.52-43.96C380.73,407.39,316.98,381.01,257.55,365.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105424677721718504560000017195230999883651746_",
    gradientUnits: "userSpaceOnUse",
    x1: 492.8166,
    y1: 436.551,
    x2: 168.8129,
    y2: 436.551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000105424677721718504560000017195230999883651746_)"
    },
    d: "      M323.07,424.31c-9.61-2.57-19.78-6-30.48-10.26c7.22,13.17,16.43,23.96,27.77,32.13c-50.56-10.47-85.95-54.35-141.31-56.3      c-35.91-1.26-55.83,22.17-93.52,47.4c29.39-16.35,64.61-24.44,89.87-18.4c48.66,11.66,72.22,53.7,114.09,64.4      c-9.51-10.52-16.56-22.71-21.61-36.18c8.3,6.08,16.43,11.13,24.43,15.13c34.83,17.44,66.74,15.53,96.23-2.65      C364.03,456.88,341.64,446.97,323.07,424.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038386121784212078680000015355160393287027363_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.697,
    y1: 463.8794,
    x2: 137.4483,
    y2: 463.8794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000038386121784212078680000015355160393287027363_)"
    },
    d: "      M292.33,462.23c-8-4-16.13-9.05-24.43-15.13c5.04,13.47,12.09,25.66,21.61,36.18c-41.87-10.7-65.44-52.74-114.09-64.4      c-25.26-6.04-60.48,2.05-89.87,18.4c84-37.7,175.27,110.52,251.97,64.73C318.47,497.19,302.38,486.14,292.33,462.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178179500552853094470000017694060658236456089_",
    gradientUnits: "userSpaceOnUse",
    x1: 594.5743,
    y1: 381.8247,
    x2: 264.4106,
    y2: 381.8247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000178179500552853094470000017694060658236456089_)"
    },
    d: "      M257.55,365.41c-28.44-7.49-49.48-10.92-65.83-11.09c61.65,11.65,116.87,51.78,163.61,54.74c30.61,1.91,55.57-5.69,70.27-28.69      C380.73,407.39,316.98,381.01,257.55,365.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032644507057967564910000015805487291368275075_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.9521,
    y1: 515.2393,
    x2: 330.5708,
    y2: 440.4272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000032644507057967564910000015805487291368275075_)"
    },
    d: "      M323.07,424.31c-9.61-2.57-19.78-6-30.48-10.26c7.22,13.17,16.43,23.96,27.77,32.13c22.75,16.3,45.49,20.4,68.19,13.4      C364.03,456.88,341.64,446.97,323.07,424.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140728932114031373510000014374807203442208417_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.1094,
    y1: 540.9861,
    x2: 293.3948,
    y2: 474.9791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000140728932114031373510000014374807203442208417_)"
    },
    d: "      M292.33,462.23c-8-4-16.13-9.05-24.43-15.13c5.04,13.47,12.09,25.66,21.61,36.18c13.86,16.43,30.39,20.21,48,18.73      C318.47,497.19,302.38,486.14,292.33,462.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121987357021403654570000000019757710460039576_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.259,
    y1: 432.1143,
    x2: 209.4968,
    y2: 432.1143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000121987357021403654570000000019757710460039576_)"
    },
    d: "      M305.55,442.09c-22.18-7.61-41.82-20.78-62.52-32c23.87,16.27,46.04,35.18,73.92,44.05      C312.81,450.49,308.99,446.44,305.55,442.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157294933633749597260000007399674429591434628_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.5337,
    y1: 464.2893,
    x2: 187.2679,
    y2: 464.2893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000157294933633749597260000007399674429591434628_)"
    },
    d: "      M215.76,437.31c23.56,19.57,41.52,43.53,69.21,53.96c-2.87-3.91-5.43-7.95-7.74-12.17C254.9,469.57,237.2,451.67,215.76,437.31z      "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167387419530041148130000009702346279599613100_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.1764,
    y1: 460.9194,
    x2: 289.8309,
    y2: 460.9194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000167387419530041148130000009702346279599613100_)"
    },
    d: "      M267.9,447.1c1.74,4.65,3.69,9.13,5.96,13.44c8.48,5.87,16.82,10.56,25,14.21c-2.39-3.73-4.56-7.9-6.52-12.52      C284.33,458.22,276.2,453.18,267.9,447.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127008409682960223610000007536815716726978739_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.9292,
    y1: 424.1151,
    x2: 328.8928,
    y2: 424.1151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000127008409682960223610000007536815716726978739_)"
    },
    d: "      M323.07,424.31c-9.61-2.57-19.78-6-30.48-10.26c2.09,3.83,4.34,7.44,6.78,10.83c11.65,4.22,22.61,7.3,32.82,9.3      C329.07,431.23,326.02,427.92,323.07,424.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000041271011803504984760000002977146286637721023_",
    cx: 487.8638,
    cy: 182.2308,
    r: 465.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F8B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31F22"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000041271011803504984760000002977146286637721023_)"
    },
    d: "     M342.42,296c-8.78-10.39-21-13.39-35.95-8.26c-17.44,5.92-24.09,19.57-38.13,26.35c-44.87,21.74-72.35,10.01-117.49,51.18     c19.26-13.43,46.31-15.74,106.7,0.14c6.05-9.05,12.87-17.27,21.13-23.88c12.57-9.95,29-11.09,43.78-16.82     C351.73,313.4,353.29,296.4,342.42,296z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158735149144804322740000010524065000011199902_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.7104,
    y1: 298.2006,
    x2: 269.1919,
    y2: 298.2006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000158735149144804322740000010524065000011199902_)"
    },
    d: "     M289.41,297.7c-3.43,2.87-6.56,5.91-9.83,8.69c19.7-1.21,40.36-21.91,62.83-10.39C325.68,283.31,306.85,294.18,289.41,297.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056419246391705728240000017573447700278796438_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.1931,
    y1: 356.0938,
    x2: 251.9595,
    y2: 356.0938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D151A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D151A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000056419246391705728240000017573447700278796438_)"
    },
    d: "     M150.85,365.27c10.22-7.13,22.57-11.09,40.88-10.95c16.35,0.17,37.39,3.6,65.83,11.09c3.04-4.53,6.26-8.83,9.73-12.88     C232.24,346.57,181.63,339.14,150.85,365.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000003078149075565424990000000208791856389019819_",
    cx: 365.7398,
    cy: 283.731,
    r: 140.0083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F8B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31F22"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000003078149075565424990000000208791856389019819_)"
    },
    d: "     M259.33,288.4c23.35,28.39,55.96-13.01,83.08,7.6C320.89,264.13,285.76,294.66,259.33,288.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056400750582834955850000000404056575512597435_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.6501,
    y1: 288.6063,
    x2: 309.9094,
    y2: 288.6063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000056400750582834955850000000404056575512597435_)"
    },
    d: "     M259.33,288.4c14.86,9.21,31.21,2.82,46.86-0.57c12.96-2.87,25.45-3.65,36.22,8.17C320.89,264.13,285.76,294.66,259.33,288.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000053505249977725019630000015675071570444657331_",
    cx: 474.3861,
    cy: 302.9845,
    r: 182.9632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F8B12D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31F22"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000053505249977725019630000015675071570444657331_)"
    },
    d: "     M342.42,296c8.74,0.31,9.44,11.4-5.88,21.62c25.35-10.74,51.1-18.53,77.23-23.39C390.34,292.7,366.6,292.96,342.42,296z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169532352948166748180000001313394422878092964_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.3777,
    y1: 298.5922,
    x2: 349.7586,
    y2: 298.5922
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000169532352948166748180000001313394422878092964_)"
    },
    d: "     M342.42,296c4.66,0.18,7,3.4,5.92,7.87c21.22-5.34,43.09-8.25,65.44-9.65C390.34,292.7,366.6,292.96,342.42,296z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraneWsLoginLogo);
export default __webpack_public_path__ + "static/media/crane-ws-login-logo.a2d055ea974fe61bdc61518c09150df0.svg";
export { ForwardRef as ReactComponent };